export default __webpack_public_path__ + "static/dismoi-screenshot-biet-thomas-mounted-website-mobile-fea89579da37ceca75c4ec7690fc551b.jpg";